import React, { ReactNode } from 'react'
import { Icon } from 'semantic-ui-react'
import usePlayerActions from '../../hooks/usePlayerActions'
import { useSelector } from '../../../../hooks/useSelector'
import formatCost from '../../../../utils/formatCost'
import { truncateCash } from '@prometheus/utils'
import { Card, Popup, Cards, Stack, Typography } from '@prometheus/components'
import PromiseCard from '@/components/PromiseCard'

interface BondMaxUpgradesPopupProps {
  children: ReactNode
}

export default ({ children }: BondMaxUpgradesPopupProps) => {
  const bond_max_upgrades = useSelector(s => s.game.options?.bond_max_upgrades) || []
  const sheet = useSelector(s => s.game.sheet)
  const level = (sheet?.bonds.max_level) || 0
  const {
    onUpgrade,
  } = usePlayerActions()

  return (
    <Popup hoverable position="bottom right" trigger={children}>
      <Card padding="sm" style={{ width: 'min(400px, calc(100vw - 20px))' }}>
        <Stack>
          <Typography variant="h4">Bond Max Deposit Upgrades <Typography variant="h4" component="span" color="secondary">Level {level + 1}</Typography></Typography>
          <Cards>
            {bond_max_upgrades.map(({ cost, max }, i) => {
              const disabled = i !== level + 1
              const isNextUpgrade = i === level + 1
              const isUpgraded = i <= level
              let color: string | undefined = undefined;
              if (isUpgraded) color = 'var(--prometheus-secondary)'
              else if (disabled) color = 'var(--prometheus-gray-500)'
              let onClick
              if (isNextUpgrade) {
                onClick = () => onUpgrade('bond_max')
              }
              return (
                <PromiseCard key={max} padding="sm" interactive ignoreGameLogic disabled={disabled} onClick={onClick}>
                  <Stack direction="row" style={{ justifyContent: 'space-between' }}>
                    <Typography bold style={{ color }}>Level {i + 1} | Max: {truncateCash(max + (sheet?.bonds.max_bonuses || 0))}</Typography>
                    {isNextUpgrade && (<Icon name="angle double up" style={{ color: 'var(--prometheus-primary)' }} size="large" />)}
                    {isUpgraded && (<Icon name="check square" style={{ color: 'var(--prometheus-secondary' }} size="large" />)}
                  </Stack>
                  <Typography style={{ color }}>{formatCost(cost)}</Typography>
                </PromiseCard>
              )
            })}
          </Cards>
        </Stack>
      </Card>
    </Popup>
  )
}
